__webpack_require__.p = "https://storage.yandexcloud.net/cft/microfronts/os-p10/pdp/";